import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {escapeHtml, getSelectedValue, setSelectedValue} from "../../Utils";
import {PqmPacket, PqmProcData} from "../pqmTypes";
import {UiRadioList} from "../../components/UiRadioList";
import {TreeSelector} from "../../TreeSelector";
import {UiTomSelect} from "../../components/UiTomSelect";
import {UiAccountSelector} from "../../components/UiAccountSelector";

export class PqmFieldAccount extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "account:*" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent(
			`<div mu="value:UiAccountSelector#value" mu-params="`
			+ escapeHtml(JSON.stringify({
				multiple: this.control === "account_accounts",
				inSameCompany: true,
			})) + `"></div>`
		);
	}

	setDisabled(disabled: boolean) {
		(this.muNamedWidget.value as unknown as UiAccountSelector).setDisabled(disabled);
	}
}

PqmFieldRegister.register(PqmFieldAccount);